import React from "react";

const BoldIcon = props => (
  <svg width={9} height={11} viewBox="0 0 9 11" {...props}>
    <defs>
      <linearGradient id="a" x1="-15.842%" x2="109.964%" y1="13.157%" y2="116.349%">
        <stop offset="0%" stopColor="#00B1FF" />
        <stop offset="72.016%" stopColor="#0060E7" />
        <stop offset="100%" stopColor="#0046DF" />
        <stop offset="100%" stopColor="#D3E1EF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(-400 -706)">
      <path fill="url(#a)" d="M0 85h1439v635H0z" />
      <rect width={730} height={1584} x={65} y={458} fill="currentColor" rx={5} />
      <g transform="translate(387 695)">
        <rect width={258} height={32} fill="#212121" rx={4} />
        <path d="M9 9h16.661v16.819H9z" />
        <path
          fill="currentColor"
          d="M19.758 16.284c.694-.49 1.18-1.262 1.18-1.962 0-1.612-1.18-2.803-2.777-2.803h-4.304v9.81h4.86c1.458 0 2.568-1.191 2.568-2.663a2.633 2.633 0 0 0-1.527-2.382zM15.87 13.27h2.083c.555 0 1.041.491 1.041 1.052 0 .56-.486 1.05-1.04 1.05H15.87V13.27zm2.43 6.307h-2.43v-2.102h2.43c.556 0 1.042.49 1.042 1.051 0 .56-.417 1.051-1.042 1.051z"
        />
      </g>
    </g>
  </svg>
);

export default BoldIcon;
